export default class Address {
	public recipientName: string;
	public careOfName: string;
	public streetAddress: string;
	public postalCode: string;
	public city: string;
	public countryCode: string;
}
